import "bootstrap";
import "jquery";

import "bootstrap/dist/css/bootstrap.css";

// Panic repair for pannellum error with Desktop Safari
import "./js/pannellum";

import * as $ from "jquery";

import * as SmartDrawings from "./smartDrawings";

import { Sd360Api } from "./api/sd360Api";
import { init360CategoryMenu } from "./tools/category360Menu";
/*
 * 360 image viewer module. Loads a single image or a tour and initializes the Pannellum viewer.
 */

let viewer;
let firstSceneLoaded = false;

function getConfig(group: string, configId: string, callback) {
    $.getJSON(`/360/config/${group}/${configId}`, callback);
}

function loadImage(url) {
    return $.get(url.replace("..", ""));
}

function start(model: SmartDrawings.Model360) {
    let sd360Api;

    if (model.configId != null) {
        getConfig(model.group,
            model.configId,
            data => {
                const cssPath = `/360/css/${model.group}/${model.configId}`;
                $("head").append(`<link rel='stylesheet' id='extracss' href='${cssPath}' type='text/css' />`);

                if (data.scenes) {
                    for (let scene in data.scenes) {
                        let currentScene = data.scenes[scene];
                        if (currentScene.hotSpots && currentScene.hotSpots.length > 0) {
                            for (let hotSpot of currentScene.hotSpots) {
                                switch (hotSpot.createTooltipFunc) {
                                    case "picture":
                                        hotSpot.createTooltipFunc = picture;
                                        hotSpot.clickHandlerFunc = openPicture;
                                        break;
                                    case "video":
                                        hotSpot.createTooltipFunc = video;
                                        hotSpot.clickHandlerFunc = openVideo;
                                        break;
                                    case "info":
                                        hotSpot.createTooltipFunc = info;
                                        hotSpot.clickHandlerFunc = openPicture;
                                        break;
                                    case "fixed":
                                        hotSpot.createTooltipFunc = fixed;
                                        hotSpot.clickHandlerFunc = openFixed;
                                        break;
                                    //case "tooltip":
                                    //    hotSpot.createTooltipFunc = tooltip;
                                    //    break;
                                    case "localVideo":
                                        hotSpot.createTooltipFunc = (window as any).localVideo;
                                        hotSpot.clickHandlerFunc = (window as any).localVideoClick;
                                        break;
                                    default:
                                }

                                switch (hotSpot.type) {
                                    case "Tooltip":
                                        hotSpot.createTooltipFunc = tooltip;
                                        hotSpot.createTooltipArgs = {
                                            id: hotSpot.id,
                                            categoryId: hotSpot.categoryId ? hotSpot.categoryId : null,
                                            text: hotSpot.text
                                        };
                                        break;
                                    case "CustomScene":
                                        hotSpot.createTooltipFunc = customScene;
                                        hotSpot.createTooltipArgs = {
                                            id: hotSpot.id,
                                            categoryId: hotSpot.categoryId ? hotSpot.categoryId : null,
                                            sceneId: hotSpot.sceneId,
                                            text: hotSpot.text
                                        };
                                        break;
                                    case "Text":
                                        hotSpot.createTooltipFunc = text;
                                        hotSpot.createTooltipArgs = {
                                            id: hotSpot.id,
                                            categoryId: hotSpot.categoryId ? hotSpot.categoryId : null,
                                            text: hotSpot.text
                                        };
                                    default:
                                }
                            }
                        }
                    }
                }

                viewer = pannellum.viewer("panorama", data);
                sd360Api = new Sd360Api(viewer, true);
                initHomeButton();

                viewer.on("load",
                    () => {
                        if (!firstSceneLoaded) {
                            firstSceneLoaded = true;
                            const sceneIds = Object.keys(data.scenes);
                            sceneIds.map(id => loadImage(data.scenes[id].panorama));

                            if (data.categories) {
                                init360CategoryMenu(viewer, data.categories, data.scenes);
                            }
                        }
                    });

                $("#container360hotspot").on("click", e => {
                    $("#container360hotspot").empty();
                    $("#container360hotspot").hide();
                });

                // Add sd360Api
                window["sd360"] = sd360Api;
            });

    } else {
        viewer = pannellum.viewer("panorama",
            {
                "type": "equirectangular",
                "panorama": model.image,
                "autoLoad": true,
                "autoRotateInactivityDelay": 5000
            });
        if (model.pitch != null) {
            viewer.setPitch(model.pitch);
        }
        if (model.yaw != null) {
            viewer.setYaw(model.yaw);
        }
        if (model.hfov != null) {
            viewer.setHfov(model.hfov);
        }
        if (model.autorotate != null) {
            viewer.startAutoRotate(model.autorotate);
        }

        sd360Api = new Sd360Api(viewer);

        initHomeButton();

        // Add sd360Api
        window["sd360"] = sd360Api;
    }
};

function initHomeButton() {
    $(".pnlm-controls-container")
        .append(
            "<div id='home-button' class='pnlm-fullscreen-toggle-button pnlm-controls pnlm-control' style='display: block; text-align: center'><i class='icon ion-md-home' style='vertical-align: middle'></i></div>");
    const fullscreen = $("#home-button");
    fullscreen.on("click", e => {
        location.reload();
    });
}

(window as any).printCoordinates = () => {
    $("#panorama").on("click", evt => {
        const [pitch, yaw] = viewer.mouseEventToCoords(evt);
        console.log("Coordinates:", JSON.stringify({ pitch: pitch, yaw: yaw }));
        console.log("hfov:", viewer.getHfov());
    });
    return "Click on panorama";
}

// Hot spot creation function for picture
function picture(hotSpotDiv, args) {
    hotSpotDiv.classList.add('custom-tooltip');
    const image = document.createElement('img');
    setHotspotAttributes(image, args);
    hotSpotDiv.appendChild(image);
}

function openPicture(event, args) {
    const image = document.createElement('img');
    image.setAttribute('src', args.url);
    $("#container360hotspot").append(image);
    $("#container360hotspot").show();
}

// Hot spot creation function for video
function video(hotSpotDiv, args) {
    hotSpotDiv.classList.add('custom-tooltip');
    var iframe = document.createElement('iframe');
    setHotspotAttributes(iframe, args);
    iframe.setAttribute('src', `${args.src}?rel=0`);
    iframe.allowFullscreen = true;
    hotSpotDiv.appendChild(iframe);
}

function openVideo(event, args) {
    //window.open(args.url);
    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', `${args.url}?rel=0`);
    iframe.setAttribute('frameborder', "0");
    //iframe.setAttribute('modestbranding', "1");
    //iframe.allowFullscreen = true;
    $("#container360hotspot").append(iframe);
    $("#container360hotspot").show();
}

// Hot spot creation function for info picture
function info(hotSpotDiv, args) {
    hotSpotDiv.classList.add('custom-info');
    const image = document.createElement('img');
    image.alt = "info";
    setHotspotAttributes(image, args);
    hotSpotDiv.appendChild(image); 
}
function fixed(hotSpotDiv, args) {
    const image = document.createElement('img');
    image.alt = "info";
    setHotspotAttributes(image, args);
    image.onclick = (e) => openFixed(e, { url: args.src });
    $("#container360fixed").append(image);
}

function openFixed(event, args) {
    openPicture(event, args);
}

function tooltip(hotSpotDiv, args) {
    hotSpotDiv.classList.add('custom-hotspot-tooltip');

    const hsDiv = createCustomHotspotDiv(hotSpotDiv, args.id, "custom-tooltip", args.categoryId);
    createTooltip(hsDiv, args.text);
}

function customScene(hotSpotDiv, args) {
    hotSpotDiv.classList.add('custom-hotspot-scene');
    hotSpotDiv.onclick = (e) => { e.preventDefault(); };
    const hsDiv = createCustomHotspotDiv(hotSpotDiv, args.id, "custom-scene", args.categoryId);
    hsDiv.onclick = (e) => { viewer.loadScene(args.sceneId); };
    createTooltip(hsDiv, args.text);
}

function text(hotSpotDiv, args) {
    hotSpotDiv.classList.add('custom-hotspot-text');
    const hsDiv = createCustomHotspotDiv(hotSpotDiv, args.id, "custom-text", args.categoryId);

    const span = document.createElement('span');
    hsDiv.appendChild(span);
    if (args.text)
        span.innerHTML = args.text;
    span.style.width = span.scrollWidth - 20 + 'px';
    span.style.marginLeft = -(span.scrollWidth - hsDiv.offsetWidth) / 2 + 'px';
    span.style.marginTop = -span.scrollHeight / 2 + 'px';
}

function setHotspotAttributes(elem: Element, attributes) {
    if (attributes.width)
        elem.setAttribute('width', attributes.width);
    if (attributes.height)
        elem.setAttribute('height', attributes.height);
    if (attributes.style)
        elem.setAttribute('style', attributes.style);
    elem.setAttribute('src', attributes.src);
}

function createCustomHotspotDiv(parent: HTMLElement, id: string, className: string, categoryId: string): HTMLDivElement {
    const div = document.createElement("div");
    div.id = id;
    div.className = div.className = className + (categoryId !== null ? ` ${categoryId}` : "");
    parent.appendChild(div);
    return div;
}

function createTooltip(parentDiv, text) {
    const span = document.createElement('span');
    parentDiv.appendChild(span);
    if (text)
        span.innerHTML = text;
    span.style.width = span.scrollWidth - 20 + 'px';
    span.style.marginLeft = -(span.scrollWidth - parentDiv.offsetWidth) / 2 + 'px';
    span.style.marginTop = -span.scrollHeight - 12 + 'px';
}

export { start };